import Grades from "./Grades";

export default Grades;